import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G6_P3_S1_Title: {
    id: `guide06.page03.slide01.title`,
  },
  G6_P3_S1_Description: {
    id: `guide06.page03.slide01.description`,
  },
  G6_P3_S1_Note: {
    id: `guide06.page03.slide01.note`,
  },
  G6_P3_S2_Title: {
    id: `guide06.page03.slide02.title`,
  },
  G6_P3_S2_Description: {
    id: `guide06.page03.slide02.description`,
  },
  G6_P3_S3_Title: {
    id: `guide06.page03.slide03.title`,
  },
  G6_P3_S3_Description: {
    id: `guide06.page03.slide03.description`,
  },
  G6_P3_S3_Caption: {
    id: `guide06.page03.slide03.caption`,
  },
});
